<div class="p-2">
  @if (!isPartnerApp || (isPartnerApp && !hasNoIndvId)) {
  <p class="static-text">
    {{ "UPLOADED_DOCUMENTS_STATIC_TEXT1" | globalTranslate }}
  </p>
  } @if (isPartnerApp && hasNoIndvId) {
  <p class="static-text">
    {{ "UPLOADED_DOCUMENTS_STATIC_TEXT1_01" | globalTranslate }}
  </p>
  } @if (ppViewTcc || readTCC) {
  <p class="static-text">
    {{
      (partnerOrgDocSwitch
        ? "UPLOADED_DOCUMENTS_STATIC_TEXT3_01"
        : "UPLOADED_DOCUMENTS_STATIC_TEXT3"
      ) | globalTranslate
    }}
  </p>
  }
  <!--Member uploaded documents PP flow -->
  @if (ppViewTcc) {
  <p class="static-text">
    {{ "DOC_UPLOAD_FAQ" | globalTranslate
    }}<a (click)="docUploadInfo()" class="learn_more pe-2"
      >{{ "here" | globalTranslate }}.</a
    >
  </p>
  } @if (readTCC && isPartnerApp) {
  <p class="static-text">
    {{ "DOC_UPLOAD_FAQ_VIEW_ONLY_TCC" | globalTranslate
    }}<a (click)="docUploadInfo()" class="learn_more pe-2"
      >{{ "here" | globalTranslate }}.</a
    >
  </p>
  } @if (ppViewTcc || readTCC) {
  <h1 class="section-header">Member Uploaded Documents</h1>
  }
  <hr />
  @if ((ppViewTcc || readTCC) && memberUploadedDocRows &&
  memberUploadedDocRows.length > 0) {
  <div class="d-none d-lg-block">
    <p><strong>Person ID Used in Search:</strong>&nbsp;{{ memberPersonId }}</p>
    <ngx-datatable
      class="bootstrap striped"
      #table
      [rows]="memberUploadedDocRows"
      [columnMode]="'force'"
      [headerHeight]="'auto'"
      [footerHeight]="50"
      [rowHeight]="'auto'"
      [limit]="5"
    >
      <ngx-datatable-column
        name="{{ memberUploadDocColumns[0].name | globalTranslate }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.name }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{ memberUploadDocColumns[1].name | globalTranslate }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.uploadedBy }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{ memberUploadDocColumns[2].name | globalTranslate }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.proofType }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{ memberUploadDocColumns[3].name | globalTranslate }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.verificationFor | globalTranslate }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{ memberUploadDocColumns[4].name | globalTranslate }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.docType }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{ memberUploadDocColumns[5].name | globalTranslate }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.uploadDt }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{ 'View Document' | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <div class="pt-0 hover-red">
            <button
              class="pt-0 btn btn-link btn-lg hover-red"
              (click)="showPdf(row)"
            >
              <span class="pe-2">{{ "View" | globalTranslate }}</span>
              <i class="fa fa-search fa-lg"></i>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  }
  <div class="nh-table-mobile d-lg-none">
    @if (memberUploadedDocRows?.length) {
    <div>
      @for (row of memberUploadedDocRows; track row) {
      <div class="table-row mb-3 pb-3">
        <div class="mobile-table-header">
          {{ memberUploadDocColumns[0].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.name }}</div>
        <br />
        <div class="mobile-table-header">
          {{ memberUploadDocColumns[1].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.uploadedBy }}</div>
        <br />
        <div class="mobile-table-header">
          {{ memberUploadDocColumns[2].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.proofType }}</div>
        <br />
        <div class="mobile-table-header">
          {{ memberUploadDocColumns[3].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">
          {{ row.verificationFor | globalTranslate }}
        </div>
        <br />
        <div class="mobile-table-header">
          {{ memberUploadDocColumns[4].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.docType }}</div>
        <br />
        <div class="mobile-table-header">
          {{ memberUploadDocColumns[5].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.uploadDt }}</div>
        <br />
        <div class="mobile-table-header">
          {{ "View Document" | globalTranslate }}
        </div>
        <hr />
        <button class="btn btn-secondary btn-sm w-100" (click)="showPdf(row)">
          <span>{{ "VIEW" | globalTranslate }} </span>@if (row.pageCount &&
          row.pageCount > 1) {
          <span>({{ row.pageCount }} {{ "Pages" | globalTranslate }}) </span>
          }<i class="fa fa-search fa-lg"></i></button
        ><br />
      </div>
      }
    </div>
    }
  </div>
  @if ((ppViewTcc || readTCC) && !memberUploadedDocRows.length) {
  <p class="mb-5">{{ "NO_DOC_MP_UPLOAD" | globalTranslate }}</p>
  }
  <!--My uploaded documents-->
  <!--Your Organization docs-->
  <h1 class="section-header">
    {{
      (isPartnerApp && partnerOrgDocSwitch
        ? "ORG_DOCUPLOAD_HEADER"
        : "UPLOADED_DOCUMENTS_STATIC_TEXT2"
      ) | globalTranslate
    }}
  </h1>
  <hr />
  @if (rows && rows.length > 0) {
  <div class="d-none d-lg-block">
    @if (isPartnerApp && partnerOrgDocSwitch) {
    <p><strong>Organization Name:</strong>&nbsp;{{ organizationName }}</p>
    } @if (isPartnerApp && partnerOrgDocSwitch) {
    <p>
      You can only see documents uploaded by you or other partners within your
      organization.
    </p>
    }
    <ngx-datatable
      class="bootstrap striped"
      #table
      [rows]="rows"
      [columnMode]="'force'"
      [headerHeight]="'auto'"
      [footerHeight]="50"
      [rowHeight]="'auto'"
      [limit]="5"
    >
      <ngx-datatable-column name="{{ columns[0].name | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.name }}</span>
        </ng-template>
      </ngx-datatable-column>
      @if (isPartnerApp && partnerOrgDocSwitch) {
      <ngx-datatable-column name="{{ columns[1].name | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.uploadedBy }}</span>
        </ng-template>
      </ngx-datatable-column>
      }
      <ngx-datatable-column
        name="{{
          (isPartnerApp && partnerOrgDocSwitch
            ? columns[2].name
            : columns[1].name
          ) | globalTranslate
        }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.proofType | globalTranslate }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{
          (isPartnerApp && partnerOrgDocSwitch
            ? columns[3].name
            : columns[2].name
          ) | globalTranslate
        }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.verificationFor | globalTranslate }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{
          (isPartnerApp && partnerOrgDocSwitch
            ? columns[4].name
            : columns[3].name
          ) | globalTranslate
        }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.docType | globalTranslate }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="{{
          (isPartnerApp && partnerOrgDocSwitch
            ? columns[5].name
            : columns[4].name
          ) | globalTranslate
        }}"
      >
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.uploadDt }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{ 'View Document' | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <div class="pt-0 hover-red">
            <button
              class="pt-0 btn btn-link btn-lg hover-red"
              (click)="showPdf(row)"
            >
              <span class="pe-2">{{ "View" | globalTranslate }}</span>
              <i class="fa fa-search fa-lg"></i>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  }

  <div class="nh-table-mobile d-lg-none">
    @if (rows.length && !isPartnerApp) {
    <div>
      @for (row of rows; track row) {
      <div class="table-row mb-3 pb-3">
        <div class="mobile-table-header">
          {{ columns[0].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.name }}</div>
        <br />
        <div class="mobile-table-header">
          {{ columns[1].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.proofType }}</div>
        <br />
        <div class="mobile-table-header">
          {{ columns[2].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">
          {{ row.verificationFor | globalTranslate }}
        </div>
        <br />
        <div class="mobile-table-header">
          {{ columns[3].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.docType }}</div>
        <br />
        <div class="mobile-table-header">
          {{ columns[4].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.uploadDt }}</div>
        <br />
        <div class="mobile-table-header">
          {{ "View Document" | globalTranslate }}
        </div>
        <hr />
        <button class="btn btn-secondary btn-sm w-100" (click)="showPdf(row)">
          <span>{{ "VIEW" | globalTranslate }} </span>@if (row.pageCount &&
          row.pageCount > 1) {
          <span>({{ row.pageCount }} {{ "Pages" | globalTranslate }}) </span>
          }<i class="fa fa-search fa-lg"></i></button
        ><br />
      </div>
      }
    </div>
    } @if (rows.length && isPartnerApp && partnerOrgDocSwitch) {
    <div>
      @for (row of rows; track row) {
      <div class="table-row mb-3 pb-3">
        <div class="mobile-table-header">
          {{ columns[0].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.name }}</div>
        <br />
        <div class="mobile-table-header">
          {{ columns[1].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.uploadedBy }}</div>
        <br />
        <div class="mobile-table-header">
          {{ columns[2].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.proofType }}</div>
        <br />
        <div class="mobile-table-header">
          {{ columns[3].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">
          {{ row.verificationFor | globalTranslate }}
        </div>
        <br />
        <div class="mobile-table-header">
          {{ columns[4].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.docType }}</div>
        <br />
        <div class="mobile-table-header">
          {{ columns[5].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.uploadDt }}</div>
        <br />
        <div class="mobile-table-header">
          {{ "View Document" | globalTranslate }}
        </div>
        <hr />
        <button class="btn btn-secondary btn-sm w-100" (click)="showPdf(row)">
          <span>{{ "VIEW" | globalTranslate }} </span>@if (row.pageCount &&
          row.pageCount > 1) {
          <span>({{ row.pageCount }} {{ "Pages" | globalTranslate }}) </span>
          }<i class="fa fa-search fa-lg"></i></button
        ><br />
      </div>
      }
    </div>
    }
  </div>
  @if (!rows.length) {
  <p class="mb-5">
    {{
      (isPartnerApp && partnerOrgDocSwitch
        ? "DO_NOT_HAVE_ORG_DOCUMENT"
        : "DO_NOT_HAVE_DOCUMENT"
      ) | globalTranslate
    }}
  </p>
  } @if ((ppViewTcc || readTCC) && imeRows && imeRows.length > 0) {
  <div class="d-none d-lg-block">
    <h1 class="section-header">
      My Uploaded Incurred Medical Expense Documents
    </h1>
    <hr />
    <ngx-datatable
      class="bootstrap striped"
      #table
      [rows]="imeRows"
      [columnMode]="'force'"
      [headerHeight]="'auto'"
      [footerHeight]="50"
      [rowHeight]="'auto'"
      [limit]="5"
    >
      <ngx-datatable-column name="{{ imeColumns[0].name | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.name }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{ imeColumns[1].name | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.expenseType }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{ imeColumns[2].name | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.docType }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{ imeColumns[3].name | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <span>{{ row.uploadDt }}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="{{ 'View Document' | globalTranslate }}">
        <ng-template
          ngx-datatable-cell-template
          let-row="row"
          let-rowIndex="rowIndex"
        >
          <div class="pt-0 hover-red">
            <button
              class="pt-0 btn btn-link btn-lg hover-red"
              (click)="showPdf(row)"
            >
              <span class="pe-2">{{ "View" | globalTranslate }}</span>
              <i class="fa fa-search fa-lg"></i>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  } @if ((ppViewTcc || readTCC) && imeRows.length && imeRows.length > 0) {
  <div class="nh-table-mobile d-lg-none">
    <h1 class="section-header">
      My Uploaded Incurred Medical Expense Documents
    </h1>
    <hr />
    @for (row of imeRows; track row) {
    <div class="table-row mb-3 pb-3">
      <div class="mobile-table-header">
        {{ imeColumns[0].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.name }}</div>
      <br />
      <div class="mobile-table-header">
        {{ imeColumns[1].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.proofType }}</div>
      <br />
      <div class="mobile-table-header">
        {{ imeColumns[2].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.docType }}</div>
      <br />
      <div class="mobile-table-header">
        {{ imeColumns[3].name | globalTranslate }}
      </div>
      <hr />
      <div class="mobile-table-data">{{ row.uploadDt }}</div>
      <br />
      <div class="mobile-table-header">"View Document"</div>
      <hr />
      <button class="btn btn-secondary btn-sm w-100" (click)="showPdf(row)">
        {{ "VIEW" | globalTranslate }}
        <i class="fa fa-search fa-lg"></i></button
      ><br />
    </div>
    }
  </div>
  }
</div>